import React, { memo } from 'react';
import PropTypes from 'prop-types';

import styles from './styles/FormLabel.module.css';

const FormLabel = ({
    children,
    htmlFor,
    required = false,
    className = '',
    ...props
}) => {
    return (
        <label 
            htmlFor={htmlFor}
            className={`${styles.label} ${className}`}
            {...props}
        >
            {children}
            {required && <span className={styles.required}>*</span>}
        </label>
    );
};

FormLabel.propTypes = {
    children: PropTypes.node.isRequired,
    htmlFor: PropTypes.string,
    required: PropTypes.bool,
    className: PropTypes.string,
};

export default memo(FormLabel);
